/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Wrapped_Streak_HeadlineInputs */

const en_us2_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`week in a row`);
	return /** @type {LocalizedString} */ (`weeks in a row`)
	
};

const pt_br2_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana seguida`);
	return /** @type {LocalizedString} */ (`semanas seguidas`)
	
};

const es_419_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana seguida`);
	return /** @type {LocalizedString} */ (`semanas seguidas`)
	
};

const pt_pt2_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana seguida`);
	return /** @type {LocalizedString} */ (`semanas seguidas`)
	
};

const fr_fr2_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semaine d'affilée`);
	return /** @type {LocalizedString} */ (`semaines d'affilée`)
	
};

const de_de2_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`Woche am Stück`);
	return /** @type {LocalizedString} */ (`Wochen am Stück`)
	
};

const it_it2_wrapped_streak_headline = /** @type {(inputs: Wrapped_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`settimana di fila`);
	return /** @type {LocalizedString} */ (`settimane di fila`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "week in a row" |
* | * | "weeks in a row" |
*
* @param {Wrapped_Streak_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_streak_headline = /** @type {((inputs: Wrapped_Streak_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Streak_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_streak_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_streak_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_streak_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_streak_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_streak_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_streak_headline(inputs)
	return en_us2_wrapped_streak_headline(inputs)
});
export { wrapped_streak_headline as "wrapped.streak_headline" }